import {
  EmojiRender,
  Icon,
  TaskForm,
  getTranslatedText,
  Loader
} from '@nile/components';

import {
  Sheet,
  Button,
  Heading,
  RadioButton,
  DisplayText
} from '@superops/ui-design-system';
import { PlusCircle } from '@styled-icons/fa-solid/PlusCircle';
import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { injectIntl, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { TicketClient, GET_RUNBOOKS } from '@nile/graphql';
import { restructureGetAllSOPs } from '@nile/banyan/src/Utils/helper';
import { TABLE_ROW_COUNT } from '@nile/rmm/src/constants';

const SliderWrapper = styled.div`
  padding: 30px;
  height: 100vh;
  overflow: auto;
  width: 30vw;
  background: #fff;
`;

const ButtonWrap = styled.div`
  padding: 8px 0;
`;

function AssociateRunbookSheetNew(props) {
  const { intl, ticket } = props;
  return (
    <div>
      <Sheet open={props.state} onClose={props.toggleSheetActive}>
        <AssociateRunbook ticket={ticket} {...props} />
      </Sheet>
    </div>
  );
}

function AssociateRunbook(props) {
  const { ticket } = props;
  const [selectedRunbook, setSelectedRunbook] = useState(ticket?.sop);
  const [listInfo, setListInfo] = useState({
    page: 1,
    pageSize: TABLE_ROW_COUNT,
    sort: {
      attribute: 'lastUpdatedTime',
      order: 'DESC'
    }
  });
  const [saveLoading, setSaveLoading] = useState(false);

  const {
    loading: loading,
    data: runbookListData
    // refetch: refreshGlobalConfigList
  } = useQuery(GET_RUNBOOKS, {
    // Here
    client: TicketClient,
    variables: {
      input: {
        sort: [
          {
            attribute: 'name',
            order: 'ASC'
          }
        ],
        condition: {
          attribute: 'status',
          operator: 'is',
          value: 'ACTIVE'
        }
      }
    },
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    onCompleted(res) {
      // setRunbooksList(res?.getRunbooks?.runbook);
    }
  });

  if (loading)
    return (
      <div className="min-width-400 height500 flex center">
        <Loader />
      </div>
    );
  const associateRunbook = () => {
    setSaveLoading(true);
    props.associateRunbook(selectedRunbook);
  };
  const stopEvents = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const onChange = (sop) => {
    setSelectedRunbook(sop);
  };

  return (
    <SliderWrapper>
      <div className="flex">
        <Heading element="h1">
          <FormattedMessage id="ticket.details.actions.associateRunbook" />
        </Heading>
        <div className="mlauto">
          <Button
            loading={saveLoading}
            id="associateRunBook"
            primary
            onClick={associateRunbook}
          >
            <FormattedMessage id="common.save" />
          </Button>
        </div>
      </div>
      <div className="flex col mt20">
        {(runbookListData?.getRunbooks?.runbook).map((item) => {
          return (
            <div
              className="p10 border br-5 mb-10 ptr"
              key={item.sopId}
              onClick={() => onChange(item)}
            >
              <div className="flex center g10">
                <RadioButton
                  // label={item.name}
                  id={item.sopId}
                  name={item.name}
                  checked={selectedRunbook?.sopId === item?.sopId}
                  onChange={() => onChange(item)}
                />

                <span className="mr8">
                  <EmojiRender emoji={item.displayIcon} size="md" />
                </span>

                <div>
                  <DisplayText size="large" weight="Medium">
                    {item.name}
                  </DisplayText>
                  <DisplayText size="small" weight="Medium">
                    {item.description}
                  </DisplayText>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </SliderWrapper>
  );
}

export default injectIntl(AssociateRunbookSheetNew);
